import { Question } from '../components/AppContext';

// Импортируем JSON файлы с вопросами
import fireTrainingData from './categories/fire_training.json';
import firstAidData from './categories/first_aid.json';
import legalTrainingData from './categories/legal_training.json';
import tacticalTrainingData from './categories/tactical_and _special _training.json';
import specialToolsData from './categories/using_special_tools.json';

interface CategoryData {
  category: string;
  questions: Array<{
    id: string;
    question: string;
    options: string[];
    correctAnswer: number;
    explanation?: string;
  }>;
}

// Функция для преобразования данных из JSON в формат Question
const transformCategoryData = (categoryData: CategoryData): Question[] => {
  return categoryData.questions.map(q => ({
    id: q.id,
    category: categoryData.category,
    question: q.question,
    options: q.options,
    correctAnswer: q.correctAnswer,
    explanation: q.explanation
  }));
};

// Загружаем и объединяем все вопросы
export const loadAllQuestions = (): Question[] => {
  // Файлы содержат массивы категорий, берем первый элемент
  const allCategories: CategoryData[] = [
    fireTrainingData[0],
    firstAidData[0],
    legalTrainingData[0],
    tacticalTrainingData[0],
    specialToolsData[0]
  ];

  const allQuestions: Question[] = [];
  
  allCategories.forEach(categoryData => {
    const questions = transformCategoryData(categoryData);
    allQuestions.push(...questions);
  });

  return allQuestions;
};

// Получить список всех категорий
export const getAllCategories = (): string[] => {
  return [
    fireTrainingData[0].category,
    firstAidData[0].category,
    legalTrainingData[0].category,
    tacticalTrainingData[0].category,
    specialToolsData[0].category
  ];
};

// Получить вопросы по категории
export const getQuestionsByCategory = (category: string): Question[] => {
  const allQuestions = loadAllQuestions();
  return allQuestions.filter(q => q.category === category);
};

// Получить случайные вопросы
export const getRandomQuestions = (count: number, category?: string): Question[] => {
  let questions = category ? getQuestionsByCategory(category) : loadAllQuestions();
  
  // Перемешиваем массив
  const shuffled = [...questions].sort(() => Math.random() - 0.5);
  
  // Возвращаем нужное количество
  return shuffled.slice(0, Math.min(count, shuffled.length));
};

export default loadAllQuestions();
